// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__aPMVu","up":"Reveal_up__2lIrH","left":"Reveal_left__q4DlD","right":"Reveal_right__OkjpP","scale":"Reveal_scale__230h5","visible":"Reveal_visible__ttAkr"};